import React, { useState } from 'react';
import { Search, Plus } from 'lucide-react';
import { useVendorContext } from '../../context/VendorContext';
import VendorListItem from './VendorListItem';
import AddVendorForm from '../AddVendor/AddVendorForm';
import './VendorList.css';

const VendorList = () => {
  const { vendors, selectedVendor, selectVendor } = useVendorContext();
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  const filteredVendors = vendors.filter(v =>
    v.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="vendor-list-container">
      <div className="vendor-list-header">
        <h1 style={{color:'#555'}}>Varkala Railway Station</h1>
        <div style={{marginTop:'-1em',marginLeft:'1em',marginBottom:'1em',fontSize:'1em',color:'#666'}}>Vendors associated with the BMS</div>

        <div className="search-box">
          <Search className="search-icon" />
          <input
            type="text"
            placeholder="Search vendors..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      
      <div className="vendor-list">
        {filteredVendors.map(vendor => (
          <VendorListItem
            key={vendor.id}
            vendor={vendor}
            isSelected={selectedVendor?.id === vendor.id}
            onClick={() => selectVendor(vendor)}
          />
        ))}
      </div>


      <div className="vendor-list-header">
        

        <button 
          className="add-vendor-btn"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          <Plus /> Add Vendor
        </button>
      </div>

      {showAddForm && (
        <AddVendorForm onClose={() => setShowAddForm(false)} />
      )}



    </div>
  );
};

export default VendorList;